import { shallowRef } from 'vue'

// The main layout's scrolling element, which the infinite-scroll views measure. Kept
// out of Pinia: an element cannot be serialised, and it only exists in the browser.
const scrollContainer = shallowRef<HTMLElement | null>(null)

export function useScrollContainer() {
    return scrollContainer
}
